import type { TFunction } from 'i18next';

import type {
  GetApiV1AnalyticsActiveUsersData,
  GetApiV1AnalyticsMetricsByMetricKeyData,
} from '@inference.engine/api-client/web';

/**
 * Derived from the generated client rather than restated, so the presets and the
 * metric catalog can only ever drift by failing to compile.
 */
export type AnalyticsRange = GetApiV1AnalyticsActiveUsersData['query']['range'];

export type AnalyticsMetricKey = GetApiV1AnalyticsMetricsByMetricKeyData['path']['metricKey'];

/** Parallel arrays: `dates[i]` is the day bucket for `values[i]`. */
export interface AnalyticsSeries {
  dates: string[];
  values: number[];
}

/** A factory, not a table: a label held in a `const` freezes at import time. */
export const buildAnalyticsRangeOptions = (
  t: TFunction<'common'>,
): ReadonlyArray<{ value: AnalyticsRange; label: string }> => [
  { value: '7d', label: t('analytics.types.last7Days') },
  { value: '14d', label: t('analytics.types.last14Days') },
];

export const DEFAULT_ANALYTICS_RANGE: AnalyticsRange = '7d';
